import { WorkingShift } from '@/types/daily.types';
import { getAvailabilityWarnings } from './helpers/availability';
import { getBreakLimitsWarning } from './helpers/breakLimits';
import { getLeftCompanyWarnings } from './helpers/leftCompany';
import { getManagerRequiredWarning } from './helpers/managerRequired';
import { getMissingSkillsWarnings } from './helpers/missingSkills';
import { getNobodyRosteredWarnings } from './helpers/nobodyRostered';
import { getOutsideHoursShiftWarnings } from './helpers/outsideHours';
import { getOverlappingSplitShiftWarnings } from './helpers/overlappingShifts';
import { getOverlappingTaskWarnings } from './helpers/overlappingTasks';
import { getAloneRookieWarnings } from './helpers/rookies';
import { getRosterMaxShiftDurationWarnings } from './helpers/rosterMaxShiftDurationWarning';
import { getWarningsForUnderageNightShifts } from './helpers/underageNightShift';
import { RosterWarningModel, WarningsProps } from './warnings.types';

export const getRosterWarnings = (props: WarningsProps): RosterWarningModel[] => {
  const { workingRoster, validationSettings, buildEmployeeOptions } = props;
  const shifts = workingRoster.shifts;

  const warningList: RosterWarningModel[] = [];

  warningList.push(...getAloneRookieWarnings(props));
  warningList.push(...getNobodyRosteredWarnings(props));

  if (validationSettings.managementAttendance) {
    const managerWarning = getManagerRequiredWarning(props);
    if (managerWarning) {
      warningList.push(managerWarning);
    }
  }

  shifts.forEach((shift: WorkingShift) => {
    const breakLimitWarning = getBreakLimitsWarning(shift, props);
    if (breakLimitWarning) {
      warningList.push(breakLimitWarning);
    }

    if (shift.assignedEmployeeId) {
      const dropdownOptions = buildEmployeeOptions(shift);
      const assignedEmployee = dropdownOptions.find(o => o.id === shift.assignedEmployeeId);

      if (assignedEmployee) {
        warningList.push(...getAvailabilityWarnings(shift, assignedEmployee, props));
        warningList.push(...getWarningsForUnderageNightShifts(shift, assignedEmployee, props));
        warningList.push(...getOverlappingSplitShiftWarnings(shift, props));
        warningList.push(...getMissingSkillsWarnings(shift, props));
        warningList.push(...getOutsideHoursShiftWarnings(shift, props));
        warningList.push(...getLeftCompanyWarnings(shift, props));
        warningList.push(...getRosterMaxShiftDurationWarnings(shift, props.contracts, props));
      }
    }
    warningList.push(...getOverlappingTaskWarnings(shift, props));
  });

  return warningList.sort((a, b) => b.severity - a.severity);
};
